// extracted by mini-css-extract-plugin
module.exports = {"hiddenPC":"privacypolicy-module--hiddenPC--1AeFx","privacy":"privacypolicy-module--privacy--3tKzR"};